import type { BadgeVariant } from '@mnd-frontend/ui';

export type MenuStateKey = keyof typeof MenuState | 'Dashboard';

export enum MenuState {
  Dashboard = 'dashboard',
  Publish = 'publish',
  Contacts = 'contacts',
  Monitor = 'monitor',
  Analyze = 'analyze',
  Reports = 'reports',
  PressroomSelector = 'pressroomSelector',
  Settings = 'settings',
  User = 'user',
  MobileNav = 'mobileNav',
  Trial = 'trial',
  Copilot = 'copilot',
  Help = 'help',
}
interface Badge {
  text: string;
  variant: BadgeVariant;
}
export interface Item {
  url: string;
  text: string;
  badge?: Badge;
  newTab?: boolean;
  activeUrl?: string | string[];
  exactMatch?: boolean;
  siteCode?: string;
  icon?: React.ReactNode;
  description?: string;
  separator?: boolean;
}

export interface MainMenuItem {
  heading: string;
  items: Item[];
  icon?: React.ReactNode;
  iconActive?: React.ReactNode;
  desktopIcon?: React.ReactNode;
  matchingRoutes?: string[];
  menuState: MenuState;
  addDebugInfo?: boolean;
  newsroomLogo?: string | null;
}
export interface Pressroom {
  __typename: 'Pressroom';
  id: string;
  name: string;
  siteCode: string;
}
